import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
import "core-js/modules/web.timers.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineComponent as _defineComponent } from 'vue';
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import { min, required } from 'vee-validate/dist/rules';
import { useForgotPassword } from '@vsf-enterprise/commercetools';
import { useWait } from '~/composables/_next/useWait';
import { useUser } from '~/composables/_next/useUser';
import AzInput from '~/components/_next/atoms/AzInput.vue';
import AzModal from '~/components/_next/molecules/AzModal.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzLoader from '~/components/_next/atoms/AzLoader.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ModalNewPasswordOrganism',
  props: {
    token: {
      type: String,
      default: ''
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var route = useRoute();
    var _useUiState = useUiState(),
      togglePasswordModal = _useUiState.togglePasswordModal,
      handleLoginNavigation = _useUiState.handleLoginNavigation;
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app,
      i18n = _useNuxt2App.i18n;
    var router = useRouter();
    var _useUser = useUser(),
      isAuthenticated = _useUser.isAuthenticated;
    var _useForgotPassword = useForgotPassword(),
      setNew = _useForgotPassword.setNew,
      forgotPasswordError = _useForgotPassword.error,
      forgotPasswordLoading = _useForgotPassword.loading;
    var _useWait = useWait(),
      startWaiter = _useWait.startWaiter,
      endWaiter = _useWait.endWaiter,
      isWaiting = _useWait.isWaiting;
    var modalRef = ref(null);
    var newPasswordObserver = ref(null);
    var form = ref({});
    extend('min', _objectSpread(_objectSpread({}, min), {}, {
      message: i18n.t('validator.min')
    }));
    extend('required', _objectSpread(_objectSpread({}, required), {}, {
      message: i18n.t('validator.empty')
    }));
    extend('password', {
      params: ['target'],
      validate: function validate(value, _ref) {
        var target = _ref.target;
        return value === target;
      },
      message: i18n.t('validator.confirmed')
    });
    var error = reactive({
      login: null,
      register: null
    });
    onMounted(function () {
      if (props.token && !isAuthenticated.value) {
        endWaiter('new-password');
        modalRef.value.modal.showModal();
      }
    });
    var closeModal = function closeModal() {
      router.push(app.localePath({
        name: 'index'
      }));
      togglePasswordModal();
    };

    /**
     * Confirms the new password
     * Closes the modal afterward
     */
    function confirmNewPassword() {
      return _confirmNewPassword.apply(this, arguments);
    }
    function _confirmNewPassword() {
      _confirmNewPassword = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var observerValidity;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              startWaiter('new-password');
              _context.next = 3;
              return newPasswordObserver.value.validate();
            case 3:
              observerValidity = _context.sent;
              if (observerValidity) {
                _context.next = 7;
                break;
              }
              endWaiter('new-password');
              return _context.abrupt("return");
            case 7:
              _context.next = 9;
              return setNew({
                tokenValue: props.token,
                newPassword: form.value.password
              });
            case 9:
              if (!forgotPasswordError.value.setNew) {
                modalRef.value.modal.close();
                setTimeout(function () {
                  handleLoginNavigation({
                    previousRoutePath: route.path,
                    nextRoutePath: route.path
                  });
                }, 100);
              }
              endWaiter('new-password');
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _confirmNewPassword.apply(this, arguments);
    }
    return {
      __sfc: true,
      props: props,
      route: route,
      togglePasswordModal: togglePasswordModal,
      handleLoginNavigation: handleLoginNavigation,
      app: app,
      i18n: i18n,
      router: router,
      isAuthenticated: isAuthenticated,
      setNew: setNew,
      forgotPasswordError: forgotPasswordError,
      forgotPasswordLoading: forgotPasswordLoading,
      startWaiter: startWaiter,
      endWaiter: endWaiter,
      isWaiting: isWaiting,
      modalRef: modalRef,
      newPasswordObserver: newPasswordObserver,
      form: form,
      error: error,
      closeModal: closeModal,
      confirmNewPassword: confirmNewPassword,
      ValidationObserver: ValidationObserver,
      ValidationProvider: ValidationProvider,
      AzInput: AzInput,
      AzModal: AzModal,
      AzButton: AzButton,
      AzLoader: AzLoader
    };
  }
});